module.exports = __webpack_public_path__ + "img/photo-57.b1ef0dd2.webp";